
import { Message } from "@/types/message";

interface UseSellerResponseSectionProps {
  isPasting: boolean;
  isProcessingAI: boolean;
  hasMessages: boolean;
  lastAIMessage?: Message | null;
}

export const useSellerResponseSection = ({
  isPasting,
  isProcessingAI,
  hasMessages,
  lastAIMessage
}: UseSellerResponseSectionProps) => {
  // Calculate if response is in progress
  const isResponseInProgress = isPasting || isProcessingAI;
  
  // Determine if we should disable the input based on state
  const isInputDisabled = isResponseInProgress;
  
  return {
    isResponseInProgress,
    isInputDisabled,
    lastAIMessage
  };
};
